import React from "react";
import './Fim.css'

function Fim(){
    return(
        <>
            <div className="modulo">
                <div className="SobreEspecialPrincipal">
                            <div className=" fimCenterDiv">

                                <h2 class="tituloFim">OBRAS 10 DIMENSÕES 2022 <br/>eventos locais, nacionais e internacionais</h2>
                                <div className="flexDiv">
                                    <div className="flexobras">
                                        <h4>
                                            <b>
                                            <br/>
                                            Águas de Al-mar
                                            <br/>
                                            <br/> 
                                            Baile dos robôs
                                            </b>
                                        </h4>
                                    </div>
                                    <div className="flexobras2">
                                        <h4>
                                            <b>
                                            Flauta Mágica
                                            <br/> 
                                            <br/> 
                                            Holograma 3D virtual <br/> Um sujeito e seus eus
                                            </b>
                                        </h4>
                                    </div>
                                </div>
                                
                                <h3>Sobre as obras apresentadas pelo projeto 10 dimensões 2022 em eventos locais, nacionais e internacionais</h3>
                                <p>
                                    <br/>
                                    1) A obra  em vídeo Águas de Al-mar  foi apresentada no Festival Internacional da Imagem- SURTROPIA em Manizales, Colômbia na categoria Cinema digital de 17 a 21 de outubro de 2022.
                                    <br/>
                                    <br/>
                                    2) A obra Baile dos robôs foi apresentada na  exposição #EM Meio 14 articulada ao # 21ART-Encontro Internacional de Arte e Tecnologia realizado em Brasília   de 9 a 23 de setembro de 2022.
                                    <br/>
                                    <br/>
                                    3) A obra Flauta Mágica  estava prevista ser apresentada em exposição exposição do IX SIIMI - Simpósio Internacional de Inovação em Mídias Interativas, realizado de 3 a 5 de novembro de 2022, junto ao Museu de Arte Contemporânea da Universidade do Chile, em Santiago do Chile. Fomos especialmente convidados para a exposição. Porém tivemos o transporte da mesma  impedida pelos bloqueios feitos por  apoiadores de Bolsonaro nas estradas. Assim, apresentamos a obra aqui, ainda em videodocumentação anterior e que será substituída assim que possível.
                                    <br/>
                                    <br/>
                                    4)A obra Holograma 3D Virtual- Um sujeito e seus eus - fase 1 foi apresentada de forma experimental em 25.11.2022  no CT/Centro de Tecnologia da UFRN como atividade local em 2022 o junto ao  ERERN/II Encontro  de Robótica Educacional do Rio Grande do Norte (24 a 26 de novembro de 2022)
                                    Estas obras são  resultado do trabalho de equipes ao longo mais de um ano de trabalho e das  equipes de 2022 e, logo mais, 2023  em particular, nas áreas de Artes Visuais, Ciência e tecnologia, redes, design, produção cultural e música.
                                    <br/>
                                </p>

                                <p>
                                Estas obras são  resultado do trabalho de equipes ao longo mais de um ano de trabalho e das  equipes de 2022 e, logo mais, 2023  em particular, nas áreas de Artes Visuais, Ciência e tecnologia, redes, design, produção cultural e música.
                                 Estes eventos  dão continuidade à recuperação da  tradição de inventividade potiguar na área de Arte e tecnologia, sendo o Rio Grande do Norte o local de nascimento do artista pioneiro no Brasil neste campo, Abraham Palatnik. 
                                O projeto 10 Dimensões 2022 foi  apoiado pelo NAC/Núcleo de Arte e cultura da UFRN, PROEX/Pró-Reitoria de Extensão da UFRN, PROPESQ/Pró-Reitoria de Pesquisa da UFRN, DEART/Departamentos de Artes, ECT/Escola de Ciência e tecnologia e EM/Escola de Música todas da UFRN e nossos parceiros Natalnet da UFRN (http://www.natalnet.br/), Media Lab/UFG/BR (https://www.medialab.ufg.br/),  PPGPC/Performances Culturais na UFG/Universidade Federal de Goiás, além de apoio da Capes/Coordenação de Aperfeiçoamento de Pessoal de Nível Superior 
                                <br/>
                                <br/>
                                </p>
                                <p>
                                    <b>OBS: Este site tem o propósito de apresentar a <wbr/>videodocumentação das obras criadas e ou<wbr/> apresentadas em 2022/23.
                                        <br/>
                                        Por hora apresentamos as obras de 2022.
                                    </b>
                                </p>

                            </div>
                            <div className="fimCenterDiv">

                                <h2 className="tituloFim">Sobre
                                    AS OBRAS APRESENTADAS PELO PROJETO 10 DIMENSÕES 2022 
                                    EM EVENTOS LOCAIS, NACIONAIS E INTERNACIONAIS
                                </h2>

                                <p>
                                    O Projeto 10 Dimensões  2022 dando continuidade a sua 
                                    trajetória  como iniciativa irradiadora para o desenvolvimento
                                     artístico contemporâneo na área de Arte e tecnologia na região
                                      Nordeste e mais especificamente no estado do Rio Grande do
                                       Norte continuou  criando, finalizando e iniciando  ou
                                        apresentando as  obras  Baile dos robôs, Flauta Mágica,
                                         Holograma 3 D virtual - Um sujeito e seus eus, Águas de
                                         Al-mar.
                                </p>

                                <p>
                                    Continuamos a manter  a  parceria com o Media Lab/UFG/BR,
                                     importante centro e rede de Arte e tecnologia no país sediado na UFG/Universidade Federal
                                      de Goiás, com ações no âmbito Latino Americano, o que tem nos proporcionado a inserção em
                                       eventos nacionais e internacionais na área. Também mantemos hoje parceria com o PPGPC/Performances
                                        Culturais na UFG/Universidade Federal de Goiás. 
                                </p>

                                <p>
                                    Compreendemos existir  uma linha evolutiva no projeto 10 Dimensões desde o ciclo Paredão eletrônico, enfatizando
                                    a cada vez com maior interesse a função poética das obras e sua relação com o público. Este ciclo implicou na construção
                                  de peças com módulos multifacetados com e feitos de reflexão da imagem, construção de interfaces sonoras de alta
                                   qualidade ou uso de interfaces sonoras de origem popular e o uso de diversos tipos de interação como por exemplo o
                                 uso do leap motion (uso dos gestos da mão) e o acionamento de interações gestuais via celulares.                
                                </p>

                                <p>
                                    A ação continua do grupo apresenta já, pois, uma articulação entre as obras,
                                     as quais mantém diálogo entre sí com desdobramentos de usos, linguagem e imaginário. Este,
                                      vinculado a um imaginário musical e de imagens intangíveis, hora evidenciados com maior ênfase no
                                     na obra Holograma 3d virtual-- um sujeito e seus eus. Em outra chave, traz à tona as relações entre 
                                     inventividade e invenção poética através de deslocamentos resultantes de um projeto poético. Podemos dizer
                                      que a familiaridade com a estrutura paredão e particularmente mini paredão e microssistemas interativos surgidos
                                       no decorrer do ciclo anterior, inspiraram o projeto Flauta Mágica e suas decorrências, o mais recente  projeto  do grupo,
                                     Holograma 3d virtual-- um sujeito e seus eus. 
                                </p>

                                <p>
                                O grupo já conta, pois,  com um conjunto de obras que começa a se articular e apresentar como conjunto em evolução
                                 poética e de linguagem. Lembramos, que o conjunto de obras anteriores foi apresentado e reorganizado nas exposições
                                  site de 2020 e 2021 e, aqui, de alguma forma estruturado em novas obras que os acolhem e repropõem sob novas premissas.
                                   Assim, o projeto de 2022 pretende apresentar estas obras anteriores e a nova obra a ser criada em 2022. As ações propostas
                                nesse período  apropriaram-se e dialogaram como imaginário popular da área musical ou de espelhos – experiência social espraiada,
                                 estabelecendo estratégias para um novo projeto, manifestando a intersecção entre imaginário coletivo e invenção erudita.
                                  Procurando apresentar o indizível , provocada pelo que e pelo dizer mas, sobretudo pela forma como se diz, <b>como afirma 
                                   Pierre Reverdy no texto Esta emoção chamada poesia (2003, pag. 1) à procura a um programa poético e que, paradoxalmente,
                                    oferece a quem entra em contato com a obra -  um estado de admiração diante do mundo (Eugen Fink, apud MERLEAU-PONTY:1999, p.10)
                                     como uma experiência singular que nos provoque  estados poéticos e de espanto (VALÉRY: 1999, p. 204). </b>
                                </p>
                                <br/>
                                <h4>MERLEAU-PONTY, M. A Fenomenologia da percepção. São Paulo: Martins Fontes, 1999. </h4>
                                
                                <h4>REVERDY, P. Sable mouvant, Au soleil du plafond, La Liberté des mers, seguido  de Cette émotion appelée poesie.
                                 Éditions d’Étienne -Alain Hubert, Poésie / Gallimard, 2003.</h4>
                                <h4>VALÉRY, Paul. Variedades. Org. João Alexandre Barbosa. São Paulo: Iluminuras, 1999.p.193-210. </h4>
                                <br/>

                                <div className="FimDivLeft">

                                    por LAURITA SALLES <br />
                                    <strong>COORDENADORA ADJUNTA DO PROJETO 10 DIMENSÕES 2022</strong>
                                </div>

                            </div>
                            <div class="espaco"></div>



                </div>
            </div>

            <div className="modulo">
                <div class="final">

                    <div class="painel" style={{backgroundImage: 'url(' + require('../campos/imagens/gif-dimen2.gif') + ')'}}>
                        <div class="divDiferente">
                            <h2>
                                DOCUMENTAÇÃO DAS OBRAS 2022/23
                            </h2>
                        </div>
                    </div>

                    <div class="participantes" style={{backgroundImage: 'url(' + require('../campos/imagens/gif-dimen6.gif') + ')'}}>
                        <h3>
                            <strong>Equipe Projeto 10 Dimensões :</strong>
                        </h3>
                        <br/>
                        2022/23
                        <br/>
                        <br/>
                        <strong>Coordenação geral:</strong>
                        Aquiles Medeiros Filgueira Burlamaqui.
                        <br/>
                        <strong>Coordenação adjunta:</strong>
                        Laurita Ricardo de Salles
                        <br/>
                        <br/>
                        <strong>Projeto e implementação da parte de impressão e recorte a laser dos minirrobôs,
                         Flauta mágica e Holograma 3D Virtual:</strong>
                        Frederico Nero Rocha de Araújo,  Matheus Pereira Batista de Macedo,
                        Otávio Augusto Cunha Barbosa. 
                        <br/>
                        <br/>
                        <strong>Apoio:</strong>
                        Protolab/IMD/UFRN.
                        <br/>
                        <br/>
                        <strong>Programação de software e hardware:</strong>
                        Christy Ally de Oliveira Lopes,  Gustavo  Henrique Lima de Araújo  e 
                        Otávio Augusto Cunha Barbosa,
                        Riquelme Pereira Soares e Vinícius Fernandes Camilo de Lima.
                        <br/>
                        <br/>
                        <strong>Composição, sonoplastia e suporte sonoro:</strong>
                        Leonardo Meneses Pereira.
                        <br/>
                        <br/>
                        <strong>Divulgação no site, vídeos e canal no YouTube:</strong>
                        Carlos José de Araújo Souza Júnior.  Christy Ally de Oliveira Lopes,
                         Gustavo  Henrique Lima de Araújo  e Vinícius Fernandes Camilo de Lima (algumas video documentações).
                        <br/>
                        <br/>
                        <strong>Concepção dos sites específicos de  exposições e obras e manutenção de todos os  sites:</strong>
                        Leo Pinheiro Leonardo e Girleno Atos Alves Martins.
                        <br/>
                        <br/>
                        <strong>Desenho visual de cartazes, área gráfica, difusão e produção cultural: </strong>
                        Andiara de Freitas Emídio.
                        <br/>
                        <strong>Outros membros do Projeto 10 Dimensões: </strong>
                        Rodrigo Montandon Born
                        <br/>
                        <br/>
                        <strong>Servidores técnico-administrativos:</strong>suporte técnico:
                        Rafael Keller Menezes e Tales Evan da Silva.
                        <br/>
                        <br/>
                        <strong>Equipe do Media Lab/BR: </strong>
                        Cleomar de Sousa Rocha, Hugo Alexandre Dantas do Nascimento
                        <br/>
                        <br/>
                        <strong>Realização: </strong>
                        Projeto 10 Dimensões / UFRN;  PPGPC/Performances Culturais da UFG e Media Lab /BR
                        <br/>
                        <br/>
                        <strong>Apoio: </strong>
                        NAC, Propesq, Proex Natalnet/UFRN, Natalnet/UFRN/ , PROAP/Capes.
                        <br/>
                        <br/>
                        <strong>Colaboração: </strong>
                        Menaf Industria de Manufaturados Plásticos e Eletrometalúrgicos LTDA.
                        <br/>
                        <br/>

                    </div>    
                </div>
            </div>
        </>
)}

export default Fim;